import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { PatientService } from "@main/app-layout/components/patient-switch/patient.service";
import { OrganizationService } from "@main/companies";
import { ControlBase } from "@mipro/custom-controls";

@Component({
    selector: "patient-consent",
    template: `
        <ng-container *ngIf="enabledPsdConfirmation">
            <p-checkbox
                [binary]="true"
                [(ngModel)]="consent"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="checkboxChange($event.checked)"
                (onBlur)="_onBlur()"
                inputId="confirm-psd">
            </p-checkbox>

            <label class="ml-2" for="confirm-psd">
                Please confirm the
                <naming-convention-label [type]="'EndUser'" [singular]="true"></naming-convention-label>
                has read and agreed to the PSD
                <span>(click </span>
                <a class="ml-1 mr-1 underline-blue" [href]="link" target="_blank">here</a>
                <span> to download)</span>
            </label>
        </ng-container>
    `,
    styles: [
        `
            .underline-blue {
                text-decoration: underline;
                color: blue;
            }
        `
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: PatientConsentComponent,
            multi: true
        }
    ]
})
export class PatientConsentComponent extends ControlBase<boolean> implements OnInit {
    private patientService = inject(PatientService);
    private organizationService = inject(OrganizationService);

    protected readonly link = `static/${encodeURIComponent("Mipro Patient Specific Direction.pdf")}`;
    protected consent = false;
    protected enabledPsdConfirmation = false;

    @Output() readonly enabledPSDConfirmationChanged = new EventEmitter<boolean>();

    @Input() masterProfileId: string = null;

    async checkboxChange(value: boolean) {
        this.onChange(value);
        /* if (this.masterProfileId) {
            await this.patientService.updateConsentState(this.masterProfileId, value);
        } */
    }

    async ngOnInit() {
        super.ngOnInit();
        this.enabledPsdConfirmation = await this.organizationService.getEnablePatientPsdConfirmation();
        this.enabledPSDConfirmationChanged.emit(this.enabledPsdConfirmation);
    }

    writeValue(obj: boolean): void {
        this.consent = obj;
    }
}
